import React from 'react'
import classNames from 'classnames'
import { selectUnit } from '@formatjs/intl-utils'
import { FormattedRelativeTime } from 'react-intl'

import UserPhoto from 'components/UserPhoto'
// TODO direct import
import withUserLayer, { UserLayerProps } from 'components/UserLayer/withUserLayer'
import MarkdownTypography from 'components/MarkdownTypography'

import { WithStyles, Theme, withStyles, createStyles } from '@material-ui/core/styles'
import { Grid, Typography, ButtonBase } from '@material-ui/core'
import Reply from '@material-ui/icons/Reply'

import { IUser } from 'protos'

interface Props {
  incoming?: boolean
  user: IUser
  message: string
  timestamp: number
  onMention?: () => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    paddingTop: theme.spacing() * 2,
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 3,
    paddingBottom: theme.spacing(),
  },
  bubbleContainer: {
    marginLeft: theme.spacing(),
  },
  bubble: {
    padding: theme.spacing(),
    borderRadius: 4,
  },
  incomingMessage: {
    backgroundColor: '#f5f5f5',
  },
  outgoingMessage: {
    backgroundColor: theme.palette.common.white,
    boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
  },
  replyIconContainer: {
    borderRadius: 16,
    padding: 4,
    marginRight: -4,
    marginBottom: -4,
  },
  replyIcon: {
    width: 16,
    height: 16,
    color: '#aaa',
  },
})

type InjectedProps = Props & UserLayerProps & WithStyles<typeof styles>

const GameChatMessage: React.FC<InjectedProps> = ({
  classes,
  timestamp,
  incoming,
  openUserLayer,
  onMention,
  message,
  user,
}) => (
    <Grid container className={classes.root}>
      <UserPhoto src={user.photoUrl} onClick={() => openUserLayer(user.userId!)} />
      <Grid item xs className={classes.bubbleContainer}>
        <div
          className={classNames(classes.bubble, {
            [classes.incomingMessage]: incoming,
            [classes.outgoingMessage]: !incoming,
          })}
        >
          <Grid container>
            <Grid item xs>
              <Typography variant="body1">
                {user.name!}
              </Typography>
            </Grid>
            <Typography variant="h3">
              <FormattedRelativeTime {...selectUnit(timestamp)} />
            </Typography>
          </Grid>
          <Grid container alignItems="flex-end">
            <Grid item xs>
              <MarkdownTypography lexer="inline" variant="body2" markdown={message} />
            </Grid>
            {incoming && (
              <ButtonBase className={classes.replyIconContainer} onClick={onMention}>
                <Reply className={classes.replyIcon} />
              </ButtonBase>
            )}
          </Grid>
        </div>
      </Grid>
    </Grid>
  )

export default withStyles(styles)(withUserLayer(GameChatMessage))
